document.addEventListener('DOMContentLoaded', function () {
    var contentElement = document.getElementById('articleContent');
    var txtMinuti = document.getElementById('txtMinuti');
    if (!contentElement || !txtMinuti) return;

    // Prendi solo il testo visibile
    var text = contentElement.innerText || contentElement.textContent || "";
    var wordCount = text.trim().split(/\s+/).length;
    var minuti = Math.floor(wordCount / 200);

    if (minuti < 1) {
        txtMinuti.textContent = "meno di 1' di lettura";
    } else if (minuti === 1) {
        txtMinuti.textContent = "~ 1' di lettura";
    } else {
        txtMinuti.textContent = "~ " + minuti + "' di lettura";
    }
});